import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4638aeee&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"
import style0 from "./Logo.vue?vue&type=style&index=0&id=4638aeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638aeee",
  null
  
)

export default component.exports